import { attr } from '@ember-data/model';
import { inject as service } from '@ember/service';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
export default EmberDataBaseFragment.extend({
  store: service(),
  script: attr('string'),
  address: attr('object-transform')
});